import { createSelector } from 'reselect'
import { getConfiguration } from 'redux/configuration/selectors'
import { isResponsiveModeEnabled } from '../visualizer/selectors'

export const getAvailableFilters = state => state.availableFilters

export const getAvailableFiltersResponsive = createSelector(
    isResponsiveModeEnabled,
    getAvailableFilters,
    (responsiveModeIsEnabled, availableFilters) => availableFilters
)

export const getFiltersFromConfiguration = createSelector(
    getConfiguration,
    (configuration) => configuration.filters
)

export const retrieveAvailableFilters = createSelector(
    getFiltersFromConfiguration,
    (state, mediaType) => mediaType,
    (filters, mediaType) => filters[mediaType] || [],
)
